import React, {Component} from 'react'
import PropTypes from 'prop-types'

import SaveFilterDialogComponent from './SaveFilterDialog.component'

class SaveFilterDialogContainer extends Component {
    static propTypes = {
      onClose: PropTypes.func,
      handleSave: PropTypes.func
    }

    constructor(props) {
      super(props)

      this.state = {
        filterName: ''
      }
    }

    handleSaveClick = (evt) => {
      evt.preventDefault()

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Save Filter',
        type: 'Datatable'
      })

      if (this.state.filterName !== '') {
        this.props.handleSave(this.state.filterName)
        this.props.onClose()
      }
    }

    handleCancelClick = (evt) => {
      evt.preventDefault()

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Cancel Save Filter',
        type: 'Datatable'
      })

      this.props.onClose()
    }

    handleChange = (evt) => {
      this.setState({
        filterName: evt.target.value
      })
    }

    render() {
      const events = {
        handleSaveClick: this.handleSaveClick,
        handleCancelClick: this.handleCancelClick,
        handleChange: this.handleChange
      }

      const {filterName} = this.state
      const {i18n} = this.props

      return (
        <SaveFilterDialogComponent events={events} filterName={filterName} i18n={i18n} />
      )
    }
}

export default SaveFilterDialogContainer
